<template>
  <div class="city-wrapper">

    <!--<fixed-popup/>-->
    <subpage-header :city-icon="cityDetails ? cityDetails.icon : null">
      <div slot="bread">
        <ul itemscope itemtype="http://schema.org/BreadcrumbList">
          <li class="mytitle1 myli" itemprop="itemListElement" itemscope itemtype="http://schema.org/ListItem">
            <a href="https://yurtlarburada.com/" class="" itemtype="https://schema.org/Thing" itemprop="item">
              <span itemprop="name">yurtlarburada.com</span>
              <span class="color-white"> / </span>
            </a>
            <meta itemprop="position" content="1"/>
          </li>

          <li class="color-white mytitle1 myli" itemprop="itemListElement" itemscope
              itemtype="http://schema.org/ListItem">
            <a :href="city_url" class="" itemtype="https://schema.org/Thing" itemprop="item">
              &nbsp;<span itemprop="name">{{ city_name }} Öğrenci Yurtları</span>
            </a>
            <meta itemprop="position" content="2"/>
          </li>
        </ul>
      </div>
      <!--     <div class="vld-parent">
              <loading :active.sync="isLoading"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="fullPage"></loading>
          </div> -->
      <span slot="title" v-if="cityDetails" v-html="pageTitle"></span>
      <div class="city-text" slot="text" style="color: #fff;
    font-size: 17px;
    opacity: 0.75;
    font-weight: 400;">
        <span v-if="cityDetails" v-html="spot"></span>
      </div>
      <div class="subpage-header-inf" slot="numbers">
        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-uni.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ cityDetails.universities_count }}</strong>
            <span>Üniversite</span>
          </div>
        </div>

        <div class="subpage-header-inf__item">
          <img src="@/assets/img/icon-dorm.svg" alt="" class="subpage-header-inf__icon icon">
          <div class="subpage-header-inf__cnt">
            <strong class="color-light-green d-block" v-if="cityDetails">{{ cityDetails.dorms_count }}</strong>
            <span>Aktif Yurt</span>
          </div>
        </div>
      </div>
    </subpage-header>
    <div class="subpage__inner">
      <div class="city-uni" style="padding-bottom: 65px;">
        <container>
          <div class="city-uni__wrp">
            <div class="section__header">
              <h2 class="section__title mb-0" v-if="cityDetails"><span class="color-light-green">{{ cityDetails.name }} Şehrindeki</span>
                Üniversiteler</h2>
              <div class="section__right">
                <v-link
                  :to="{ name: 'CityDetailUnivercities' }"
                  title="Tüm Üniversiteleri Gör"
                  class="button--text mr-15 mobile-all"
                  v-if="cityDetails && cityDetails.universities.length > 7"
                />
                <v-button
                  icon="icon-arrow-left"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-prev"
                />
                <v-button
                  icon="icon-arrow-right"
                  icon-position="left"
                  class="circle white icon-xs xs js-uni-slider-next"
                />
              </div>
            </div>
            <swiper class="city-uni-slider" :options="swiperOption" v-if="cityDetails">
              <swiper-slide v-for="university in cityDetails.universities" :key="university.id"
                            class="city-uni-slider__item">
                <router-link :to="{ name: 'University', params: { slug: university.slug }}">
                  <uni-card :uni="university"/>
                </router-link>
              </swiper-slide>
            </swiper>
          </div>

        </container>
      </div>

      <div class="gen" ref="dormTab">
        <container>
          <div class="dorm-tab">
            <div class="dorm-tab__header">
              <DormTabNav :tabs="tabs"/>

              <!--<div class="mobile-dropdown" @click="edit">-->
              <!--<span class="filtre">-->
              <!--<svg-icon type="icon-filter"/>-->
              <!--</span>-->
              <!--<select-box title="Yurtları Filtrele"/>-->
              <!--</div>-->
              <!--<div class="section__right" v-if="show">-->
              <!--<div class="section__select">-->
              <!--<select-box :options="cities" title="Şehir Seçiniz"/>-->
              <!--</div>-->

              <!--<div class="section__select">-->
              <!--<select-box :options="dormTypes" title="Yurt Tipi Seçiniz"/>-->
              <!--</div>-->
              <!--</div>-->

              <div class="desktop-drop">
                <div class="section__right">
                  <div class="section__select" v-if="cityDetails">
                    <VueSelectTempCity placeholder="İlçe Seç" :options="cityDetails.districts"
                                       @onselect="selectDistrict"/>
                  </div>
                </div>
              </div>
            </div>
            <router-view/>
          </div>
        </container>
      </div>
      <container>
        <div class="seo-text" v-if="cityDetails">
          <p v-html="getlistseo"></p> <br>
          <v-link
            class="button--more color-white subpage-header__btn seo-btn"
            :title="cityDetails.name + ' Hakkında Merak Edilenler'"
            icon="icon-arrow-long-right"
            icon-position="right"
            :to="{ name: 'CityDetailAbout', params: { id: this.$route.params.id, slug: this.$route.params.city }}"
            slot="button"
          />
        </div>
      </container>
    </div>
    <!-- Fixed Button -->
    <v-button v-if="showGetPrice && opt !== null"
              class="button green round getBid my"
              icon="icon-fiyat-sor"
              icon-position="left"
              title="Yurt Fiyatlarını Öğren"
              @click.native="showSmsModal()"
    />
    <!-- Fixed Button End -->
    <!-- Fixed Button -->
    <!--        <v-button v-if="showGetPrice"
            class="button green round getBid my"
            icon="icon-fiyat-sor"
            icon-position="left"
            title="Yurtlar Beni Arasın"
            @click.native="showSmsModal()"
          /> -->
    <!-- Fixed Button End -->
    <Modal2 :active="showSuccessMessage" @onModalClose="closeModal2">
      <div slot="content">
        <div class="login-box" style="margin: 0 auto">
          <h2 class="login-box__title">MESAJINIZ GÖNDERİLDİ!</h2>
          <div class="or">
            <!-- <img src="@/assets/img/mail-icon.png" class="preloader-svg" width="40"> -->
            <p><span class="mycolorBlue">İlginiz İçin Teşekkür Ederiz.</span></p>
            <p><span class="mycolorBlue">Arkadaşlarımız en yakın zamanda sizinle iletişime geçecek.</span></p>
          </div>
        </div>
      </div>
    </Modal2>
    <Modal2 :active="showModal" @onModalClose="closeModal">
      <div slot="content">
        <div class="dorm-form__inner mydorm-form-inner ">
          <div class="dorm-form__form">
            <div class="dorm-form-tab">
              <div icon="icon-mail" class="dorm-form-tab__item mycolor mycursor1">
                <svg viewBox="0 0 20 20" class="icon" style="font-size: 30px; color: rgb(235, 96, 129);">
                  <use xlink:href="/icon/icons.svg#icon-fiyat-sor"></use>
                </svg>
                <div class="dorm-form-tab__title">YURTLAR BENİ ARASIN</div>
                <!-- <div class="dorm-form-tab__title">{{ smsarea }} TÜM YURTLARDAN TEKLİF AL</div> -->
              </div>
            </div>
            <div id="my-form" ref="myMessageForm">
              <v-input ref="myInput" placeholder="Ad Soyad" v-model="messageForm.name" v-on:keyup.native="saveForm"/>
              <label for="password" v-if="emptyName" class="myValidationText">Bu kısım boş geçilemez!</label>
              <v-select
                v-if="messageForm.university_name === 'Üniversite Seç' || messageForm.university_name === null || messageForm.university_name ===''"
                :options="universities" placeholder="Üniversite Seç" @onselect="selectUniversity"/>
              <VueSelectTempCity v-else :options="universities" placeholder="Üniversite Seç"
                                 @onselect="selectUniversity"/>
              <label for="password" v-if="emptyUniversity" class="myValidationText">Bu kısım boş geçilemez!</label>
              <VueSelect2
                v-if="messageForm.faculty_name === 'Fakülte Seç' && messageForm.university_name !='Üniversite Seç'"
                :options="faculties" placeholder='Fakülte Seç' @onselect="selectFaculty"/>
              <VueSelectTempFaculty v-else-if="facultyEnabled && messageForm.faculty_name !='Fakülte Seç'"
                                    placeholder="Fakülte Seç" :options="faculties" @onselect="selectFaculty"/>
              <SelectBox2 v-else myplaceholder="Fakülte Seç" :options="faculties" :title="messageForm.faculty_name"
                          @onselect="selectFaculty" disabled/>
              <label for="password" v-if="emptyFaculty" class="myValidationText">Bu kısım boş geçilemez!</label>
              <VueInputRestricted placeholder="Telefon No" v-on:keyup.native="saveForm" v-model="messageForm.phone"/>
              <label for="phone" v-if="emptyPhone" class="myValidationText">Bu kısım boş geçilemez!</label>
              <label for="phone" v-if="falsePhone" class="myValidationText">Telefon numarası 0 ile başlamalıdır!</label>
              <label for="phone" v-if="shortPhone" class="myValidationText">Telefon numarası 11 hane olmalıdır!</label>
              <v-input type="text" placeholder="E-Posta Adresi" v-on:keyup.native="saveForm"
                       v-model="messageForm.email"/>
              <label for="password" v-if="falseEmail" class="myValidationText">Geçersiz e-posta formatı!</label>
              <label for="password" v-if="emptyEmail" class="myValidationText">Bu kısım boş geçilemez!</label>
            </div>
            <v-button
              class="red fw mt-15 dorm-form__submit"
              title="GÖNDER"
              @click.native="sendSmsAll()"
            />
          </div>

        </div>
      </div>
    </Modal2>
  </div>
</template>

<script>
import SubpageHeader from '@/components/SubpageHeader'
import UniCard from '@/components/UniCard'
import DormTabNav from '@/components/City/DormTabNavCity'
import Modal2 from '@/components/Modal2'
import VueInputRestricted from '@/components/VueInputRestricted'
import SelectBox2 from '@/components/SelectBox2'
import axios from 'axios'
import { mapGetters } from 'vuex'
import {
  GET_CITY_DETAILS
} from '@/store/actions.type'
// import Loading from 'vue-loading-overlay'
import VueSelectTempCity from '@/components/VueSelectTempCity'
import VueSelectTempFaculty from '@/components/VueSelectTempFaculty'
import VueSelect2 from '@/components/VueSelect2'

export default {
  name: 'City',
  components: {
    SubpageHeader,
    UniCard,
    SelectBox2,
    DormTabNav,
    Modal2,
    VueInputRestricted,
    VueSelectTempCity,
    VueSelectTempFaculty,
    VueSelect2
  },
  metaInfo () {
    return {
      // if no subcomponents specify a metaInfo.title, this title will be used
      title: this.cityDetails ? this.cityDetails.detail_title : '',
      meta: [
        {
          vmid: 'description',
          name: 'description',
          content: this.cityDetails ? this.cityDetails.detail_description : ''
        },
        { vmid: 'keywords', name: 'keywords', content: this.cityDetails ? this.cityDetails.detail_keywords : '' }
      ],
      link: [
        { vmid: 'canonical', rel: 'canonical', href: window.location.origin + this.fullPath } // this.page_url }
      ]
    }
  },
  data () {
    return {
      list_seo: '',
      fullPath: '',
      facultyEnabled: false,
      showSuccessMessage: false,
      smsarea: '',
      list: '',
      list_id: '',
      city_name: '',
      city_id: '',
      isLoading: false,
      fullPage: true,
      city_url: '',
      page_url: '',
      universities: [],
      faculties: [],
      showGetPrice: true,
      messageForm: {
        dorm_id: null,
        name: null,
        email: null,
        university_id: null,
        faculty_id: null,
        phone: null,
        university_name: 'Üniversite Seç',
        faculty_name: 'Fakülte Seç'
      },
      showModal: false,
      falseEmail: false,
      falsePhone: false,
      shortPhone: false,
      emptyName: false,
      emptyPhone: false,
      emptyEmail: false,
      emptyEmail2: false,
      emptyUniversity: false,
      emptyFaculty: false,
      currentRouteName: '',
      tabs: [
        {
          id: 2,
          typeID: 2,
          cat: 'female',
          title: '<span class="color-pink">Kız <literal> Öğrenci Yurtları </literal>',
          icon: require('@/assets/img/icon-female.svg'),
          active: false
        },
        {
          id: 1,
          typeID: 1,
          cat: 'male',
          title: '<span class="color-blue">Erkek <literal> Öğrenci Yurtları </literal>',
          icon: require('@/assets/img/icon-male.svg'),
          active: false
        }
      ],
      swiperOption: {
        slidesPerView: 4,
        speed: 500,
        spaceBetween: 20,
        breakpoints: {
          640: {
            slidesPerView: 1,
            centeredSlides: true

          },
          320: {
            slidesPerView: 1
          }
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        },
        navigation: {
          nextEl: '.js-uni-slider-next',
          prevEl: '.js-uni-slider-prev'
        }
      },
      gender: null,
      district: 'İlçe Seçiniz',
      districtGender: null,
      opt: null,
      errors: [],
      currentDistrict: null,
      districts: []
    }
  },
  methods: {
    saveForm () {
      window.localStorage.setItem('username', this.messageForm.name)
      window.localStorage.setItem('mail', this.messageForm.email)
      window.localStorage.setItem('phone1', this.messageForm.phone)
    },
    sendSmsAll () {
      this.falseEmail = false
      this.falsePhone = false
      this.shortPhone = false
      this.emptyName = false
      this.emptyPhone = false
      this.emptyEmail = false
      this.emptyUniversity = false
      this.emptyFaculty = false
      const verifiedMail = this.$helpers.validateEmail(this.messageForm.email)
      var self = this
      if (this.isLogin === '') {
        this.universities.forEach((data) => {
          if (data.id === self.messageForm.university_id) {
            // self.university_name = data.name
            window.localStorage.setItem('university_name', data.name)
          }
        })
        if (this.messageForm.faculty_id && this.faculties) {
          this.faculties.forEach((data) => {
            if (data.id === self.messageForm.faculty_id) {
              // self.university_name = data.name
              window.localStorage.setItem('faculty_name', data.name)
            }
          })
        }
        /*                 window.localStorage.setItem('name', this.messageForm.name)
                window.localStorage.setItem('mail', this.messageForm.email)
                window.localStorage.setItem('phone1', this.messageForm.phone)
                window.localStorage.setItem('university_id', this.messageForm.university_id)
                window.localStorage.setItem('faculty_id', this.messageForm.faculty_id) */
      }

      if (!this.messageForm.email) {
        this.emptyEmail = true
      } else if (this.messageForm.email && !verifiedMail) {
        this.falseEmail = true
      }
      if (!this.messageForm.name) {
        this.emptyName = true
      }
      if (!this.messageForm.phone) {
        this.emptyPhone = true
      }

      if (this.messageForm.phone && !this.messageForm.phone.startsWith('0')) {
        this.falsePhone = true
      }

      if (this.messageForm.phone && !this.falsePhone && this.messageForm.phone.length !== 11) {
        this.shortPhone = true
      }

      if (!this.messageForm.university_id || this.messageForm.university_id === 'null') {
        this.emptyUniversity = true
      }

      if (!this.messageForm.faculty_id || this.messageForm.faculty_id === 'null') {
        this.emptyFaculty = true
      }

      if (!this.emptyName && !this.emptyEmail && !this.falseEmail && verifiedMail && !this.emptyPhone && !this.falsePhone && !this.shortPhone && !this.emptyUniversity) {
        axios.post(`/site/dorm/message/multiple`, {
          email: this.messageForm.email,
          name: this.messageForm.name,
          phone: this.messageForm.phone,
          university_id: this.messageForm.university_id,
          faculty_id: this.messageForm.faculty_id,
          list: this.list,
          list_id: this.list_id
        })
          .then(response => {
            //          this.isLoading = false
            this.closeModal()
            this.showSuccessMessage = true
          })
          .catch(e => {
            self.errors.push(e)
          })
      }
    },
    selectFaculty (opt) {
      this.messageForm.faculty_name = opt.name
      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
    },
    closeModal () {
      this.showModal = false
      this.showGetPrice = true
    },
    closeModal2 () {
      this.showSuccessMessage = false
    },
    showSmsModal () {
      this.getUniversities()
      if (this.district) {
        this.smsarea = this.opt.name.toUpperCase() + ' İLÇESİNDEKİ'
        this.list = 'district'
        this.list_id = this.opt.id
      } else {
        this.smsarea = this.city_name.toUpperCase() + ' ŞEHRİNDEKİ'
        this.list = 'city'
        this.list_id = this.city_id
      }
      if (!window.localStorage.getItem('mail') || window.localStorage.getItem('mail') === '' || window.localStorage.getItem('mail') === 'null') {
        this.messageForm.email = ''
      } else {
        this.messageForm.email = window.localStorage.getItem('mail')
      }
      if (!window.localStorage.getItem('username') || window.localStorage.getItem('username') === '' || window.localStorage.getItem('username') === 'null') {
        this.messageForm.name = ''
      } else {
        this.messageForm.name = window.localStorage.getItem('username')
      }
      if (!window.localStorage.getItem('phone1') || window.localStorage.getItem('phone1') === '' || window.localStorage.getItem('phone1') === 'null') {
        this.messageForm.phone = ''
      } else {
        this.messageForm.phone = window.localStorage.getItem('phone1')
        this.messageForm.university_id = window.localStorage.getItem('university_id')
        this.messageForm.faculty_id = window.localStorage.getItem('faculty_id')
      }
      if (!window.localStorage.getItem('university_name') || window.localStorage.getItem('university_name') === '' || window.localStorage.getItem('university_name') === 'null') {
        this.messageForm.university_name = 'Üniversite Seç'
        this.facultyEnabled = false
      } else {
        this.facultyEnabled = true
        let self = this
        axios.get(`/selected/faculties/${window.localStorage.getItem('university_id')}`)
          .then(response => {
            self.faculties = response.data
          })
        this.messageForm.university_name = window.localStorage.getItem('university_name')
      }

      if (!window.localStorage.getItem('faculty_name') || window.localStorage.getItem('faculty_name') === 'null' || window.localStorage.getItem('faculty_name') === 'null') {
        this.messageForm.faculty_name = 'Fakülte Seç'
      } else {
        this.messageForm.faculty_name = window.localStorage.getItem('faculty_name')
      }
      this.showModal = true
      this.showGetPrice = false
    },
    checkGender () {
      const type = (this.$attrs.redirect || false) ? this.$route.params.slug : this.$route.params.type
      if (type && type.includes('erkek')) {
        this.gender = 'Erkek'
        this.typeID = 1
      } else if (type && type.includes('kiz')) {
        this.gender = 'Kız'
        this.typeID = 2
      } else {
        this.gender = null
      }
    },
    checkDistrict () {
      if (!this.$route.params.district) {
        if (this.$route.fullPath.includes('ilcesi')) {
          this.district = 'empty' // ''this.$route.params.district
        } else {
          this.district = 'İlçe Seçiniz'
        }
      } else {

        // this.district = $route.params.district
      }
      if (this.$route.fullPath.includes('ilcesi')) {
        // this.district = 'empty' // ''this.$route.params.district
      } else {
        window.localStorage.setItem('district_name', '')
      }
    },
    checkCityDetails () {
      const slug = this.$route.params.city
      if (this.cityDetails) {
        if (this.cityDetails.slug !== slug) {
          this.$store.dispatch(GET_CITY_DETAILS, null)
          this.getCityDetails()
        }
      } else {
        this.getCityDetails()
      }
    },
    getCityDetails () {
      let self = this
      this.isLoading = true
      axios.get(`/site/cities/${self.$route.params.city}`)
        .then(response => {
          this.isLoading = false
          response.data.districts = response.data.districts.sort((a, b) => a.name.toLocaleLowerCase('tr').localeCompare(b.name.toLocaleLowerCase('tr')))
          const dene = { id: 5555, name: 'Tüm İlçeler' }
          self.districts = response.data.districts.unshift(dene)

          console.log('response', response)
          self.$store.dispatch(GET_CITY_DETAILS, response.data)
          self.city_name = response.data.name
          self.city_id = response.data.id
          self.city_url = window.location.origin + '/' + response.data.slug + '-ozel-ogrenci-yurtlari/'
          self.page_url = window.location.origin + '/' + response.data.slug + '-ozel-ogrenci-yurtlari/'
          // self.cityDetails = response.data
        })
        .catch(e => {
          self.errors.push(e)
        })
    },
    getUniversities () {
      let self = this
      axios.get('/selected/universities')
        .then(response => {
          self.universities = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectUniversity (opt) {
      this.facultyEnabled = true
      this.messageForm.university_id = opt.id
      this.messageForm.university_name = opt.name
      window.localStorage.setItem('university_name', opt.name)
      window.localStorage.setItem('university_id', opt.id)
      let self = this
      axios.get(`/selected/faculties/${opt.id}`)
        .then(response => {
          self.faculties = response.data
        })
        .catch(e => {
          this.errors.push(e)
        })
    },
    selectFacultyOnForm (opt) {
      this.messageForm.faculty_name = opt.name
      window.localStorage.setItem('faculty_id', opt.id)
      window.localStorage.setItem('faculty_name', opt.name)
    },
    selectDistrict (opt) {
      this.district = true
      this.opt = opt
      window.localStorage.setItem('district_name', opt.name)
      window.localStorage.setItem('city', this.cityDetails.name)

      var route

      if (opt.name === 'Tüm İlçeler') {
        route = { name: 'City', params: { slug: this.$route.params.slug } }
      } else {
        // et route = { name: 'CityDistrict', params: { slug: slug, district: opt.slug } }
        route = '/' + this.$route.params.city + '-' + opt.slug + '-ilcesi-ogrenci-yurtlari/'
        /*       if (this.$route.params.type === 'erkek') {
        route = { name: 'CityDistrictGender', params: { slug: slug, district: opt.slug, type: 'erkek' } }
      } else if (this.$route.params.type === 'kiz') {
        route = { name: 'CityDistrictGender', params: { slug: slug, district: opt.slug, type: 'kiz' } }
      } */

        if (this.$route.params.type) {
          if (this.$route.params.type.includes('erkek')) {
            if (!opt.slug.includes('ilcesi')) {
              route = '/' + this.$route.params.city + '-' + opt.slug + '-ilcesi-erkek-ogrenci-yurtlari/'
            } else {
              route = '/' + this.$route.params.city + '-' + opt.slug + '-erkek-ogrenci-yurtlari/'
            }

            // route = { name: 'UniversityFacultyGender', params: { slug: slug, faculty: opt.slug, type: 'erkek' } }
          } else if (this.$route.params.type === 'kiz' || this.$route.params.type === '-kiz' || this.$route.params.type === '-ozel-kiz' || this.$route.params.type === 'ozel-kiz') {
            if (!opt.slug.includes('ilcesi')) {
              route = '/' + this.$route.params.city + '-' + opt.slug + '-ilcesi-kiz-ogrenci-yurtlari/'
            } else {
              route = '/' + this.$route.params.city + '-' + opt.slug + '-kiz-ogrenci-yurtlari/'
            }
          }
          // route = { name: 'UniversityFacultyGender', params: { slug: slug, faculty: opt.slug, type: 'kiz' } }
        }
      }
      this.$router.push(route)
      // this.$emit('selectCity', opt)
    },
    filterDistrict (district) {
      return this.cityDetails.districts.find((item) => item.slug === district)
    },
    checkPagination () {
      if (this.currentRouteName === this.$route.name) {
        if (this.$route.params.page > 1) {
          window.scrollTo(0, this.$refs.dormTab.offsetTop)
        }
      }
    }
  },
  computed: {
    ...mapGetters(['cityDetails']),
    getlistseo () {
      if (this.$route.fullPath.includes('ilcesi')) {
        // eslint-disable-next-line vue/no-async-in-computed-properties
        axios.get(`/site/cities/dorms/${this.$route.params.city}?district=${this.$route.params.district}`)
          .then(response => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.list_seo = response.data.district.list_seo
          })
          .catch(e => {
            // eslint-disable-next-line vue/no-side-effects-in-computed-properties
            this.errors.push(e)
          })
        return this.list_seo
      } else {
        return this.cityDetails.list_seo
      }
    },
    /*     getGender() {
      if(this.gender == 'Kız') {
        return 'kiz'
      } else {
        return 'erkek'
      }
    }, */
    pageTitle () {
      const titleTemplate = 'Öğrenci Yurtları'
      let title = `<span class="color-light-green">${this.city_name} </span>Özel ${titleTemplate}`
      const route = this.$route.params
      if (route.district) {
        const district = this.filterDistrict(route.district)
        if (this.gender) {
          title = `<span class="color-light-green">${this.city_name} ${district.name} </span>${this.gender} ${titleTemplate}`
        } else {
          title = `<span class="color-light-green">${this.city_name} ${district.name} </span>${titleTemplate}`
        }
      } else if (this.gender) {
        title = `<span class="color-light-green">${this.city_name} </span> ${this.gender} ${titleTemplate}`
      }

      return title
    },
    spot () {
      let title = this.cityDetails.spot
      const route = this.$route.params
      if (route.district) {
        const district = this.filterDistrict(route.district)
        if (this.gender === 'Erkek') {
          title = district.male_spot
        } else if (this.gender === 'Kız') {
          title = district.female_spot
        } else {
          title = district.spot
        }
      } else if (this.gender) {
        if (this.gender === 'Erkek') {
          title = this.cityDetails.male_spot
        } else if (this.gender === 'Kız') {
          title = this.cityDetails.female_spot
        }
      }
      return title
    }
  },
  created () {
    this.checkCityDetails()
    this.checkGender()
    this.checkDistrict()
    var myString = this.$route.fullPath
    var lastChar = myString[myString.length - 1]

    if (lastChar === '/') {
      this.fullPath = this.$route.fullPath
    } else {
      this.fullPath = this.$route.fullPath + '/'
    }
  },
  mounted () {
    // this.getCityDetails()
    this.checkPagination()
    this.checkDistrict()
    this.currentRouteName = this.$route.name
  },
  watch: {
    $route () {
      this.checkGender()
      this.checkPagination()
      this.checkDistrict()

      if (!this.$route.fullPath.includes('ilcesi')) {
        this.district = 'İlçe Seçiniz'
      }
      // this.checkDistrictGender()
    }
  },
  beforeDestroy () {
    // this.$store.dispatch(GET_CITY_DETAILS, null)
  }
}
</script>

<style lang="scss">
@import "../../assets/scss/components/city";
@import "../../assets/scss/components/pagination-new";
@import "../../assets/scss/components/dorm-tab";

/*.info-card {*/
/*height: auto !important;*/
/*}*/

.wrapper {
  padding-bottom: 170px;
}

.dorm-tab__header {
  margin-top: -90px;
}

.select__title {
  font-size: 17px !important;
}

.city-text p {
  color: #fff !important;
}

.mytitle1 {
  font-size: 15px;
  color: white;
}

.my {
  // padding: 10px 20px !important;
  //  padding-bottom: 5px;
  bottom: 20px;
}
</style>
